import React from 'react';
import pt from 'prop-types';
import { Checkbox, FormControlLabel, Stack, Typography } from '@metarouter-private/mr-mui';
import { useResyncIntent } from 'app/components/analytics-builder/identity-sync-card/ResyncIntentContext';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import { HOSTING_TYPES } from 'app/components/analytics-builder/analytics-builder-file-hosting';

export default function ResyncToggle({ syncName, syncFriendlyName, fileHostingType }) {
  const { ecmStandAloneSyncEnabled } = useFeatureEnabled(FEATURE_FLAGS.ecmStandAloneSync);
  const { getEnableResync, setEnableResync } = useResyncIntent();
  const checked = getEnableResync(syncName);

  // Sync Config Refresh has no effect in stand-alone sync mode: the build pipeline does not
  // embed sync versions into stand-alone files, so the runtime cannot detect changes.
  if (ecmStandAloneSyncEnabled) return null;

  const isAutoDeploy = fileHostingType === HOSTING_TYPES.metaRouter;
  const deployAction = isAutoDeploy ? 'upload this file to your cluster' : 'download and deploy this file';

  return (
    <Stack spacing={0.5}>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={event => setEnableResync(syncName, event.target.checked)} />}
        label={
          <Typography variant="body2">
            Auto-resync <strong>{syncFriendlyName}</strong> on settings change
          </Typography>
        }
      />
      <Typography variant="caption" color="text.secondary">
        When enabled, returning users will re-sync with the latest settings. Changes take effect after you{' '}
        {deployAction}.
      </Typography>
    </Stack>
  );
}

ResyncToggle.propTypes = {
  syncName: pt.string.isRequired,
  syncFriendlyName: pt.string.isRequired,
  fileHostingType: pt.string,
};
